






























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetHospitals } from "@/request/cdr";
@Component({})
export default class CdrGerenxinxi extends Vue {
  @Prop()
  private patient: any;
  private hospitals: any[] = [];
  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }
  /**
   * @description 获得所有分中心的列表
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.$route.query.project_id
      }
    };
    GetHospitals(this, params).then((data: any) => {
      this.hospitals = data;
    });
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    this.$store.commit("updateCdrIfCompose", true);
  }
  /**
   * @description 保存
   */
  private save() {
    this.$emit("save");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchHospitals();
  }
}
